<input
  type="radio"
  [id]="id"
  [name]="name"
  [class]="inputClasses"
  [checked]="selected()"
  (change)="handleInputChange()"
/>
<label [for]="id" [class]="labelClasses" [title]="labelTitle()">
  <span class="tw-line-clamp-2 tw-break-words" #labelContent>
    <ng-content></ng-content>
  </span>
  <span class="tw-shrink-0 [&_bit-berry]:tw-flex" [hidden]="!hasBerry()">
    <ng-content select="bit-berry"></ng-content>
  </span>
</label>
